import * as React from 'react';
import type { SVGProps } from 'react';
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgInfo = ({ title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    width={24}
    height={24}
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <g>
      <g>
        <path
          d='M12 8.5C11.586 8.5 11.25 8.164 11.25 7.75C11.25 7.336 11.586 7 12 7C12.414 7 12.75 7.336 12.75 7.75C12.75 8.164 12.414 8.5 12 8.5Z'
          fill=''
        />
        <path d='M11.5 11C11.5 10.724 11.724 10.5 12 10.5C12.276 10.5 12.5 10.724 12.5 11V17.5H11.5V11Z' fill='' />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M2 12C2 17.514 6.486 22 12 22C17.514 22 22 17.514 22 12C22 6.486 17.514 2 12 2C6.486 2 2 6.486 2 12ZM3 12C3 7.038 7.038 3 12 3C16.962 3 21 7.038 21 12C21 16.962 16.962 21 12 21C7.038 21 3 16.962 3 12Z'
          fill=''
        />
      </g>
    </g>
  </svg>
);
export default SvgInfo;
